<template>
  <span>
    <vue-timepicker
      :format="time_format"
      hide-clear-button
      auto-scroll
      advanced-keyboard
      :minute-interval="minute_interval"
      v-model="time_data"
      @change="handle_picker_change"
      @open="$emit('time-picker-opened')"
    ></vue-timepicker>
  </span>
</template>

<script>
import { format } from "date-fns";

import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

export default {
  name: "TimePicker",
  components: {
    VueTimepicker
  },
  model: {
    prop: "time",
    event: "time-changed"
  },
  props: {
    time: {
      type: String
    }
  },
  computed: {
    time_data: {
      get: function() {
        let time = this.time;
        let time_obj_return = {
          HH: "",
          hh: "",
          mm: "",
          a: ""
        };

        this.$store.getters.get_general_settings; //having this.$store.getters.get_general_settings absolutely required for reactivity, or else 17:00 becomes 5am when toggle 12hrs and 24hrs. Especially in setting page.

        if (time) {
          if (time == "::00" || time == "::") {
            return time_obj_return;
          }
          let time_parts = time.split(":");
          time_parts[0] = time_parts[0] ? time_parts[0] : "00";
          time_parts[1] = time_parts[1] ? time_parts[1] : "00";
          time_parts[2] = time_parts[2] ? time_parts[2] : "00";
          time = time_parts.join(":");
          //need to validate the incoming format
          let time_obj = this.date_parse("2000-01-01 " + time);
          time_obj_return = {
            HH: format(time_obj, "HH"),
            hh: format(time_obj, "hh"),
            mm: format(time_obj, "mm"),
            a: format(time_obj, "a").toLocaleLowerCase()
          };
        }
        return time_obj_return;
      },
      set: function(new_value) {
        new_value;
      }
    },
    time_format() {
      let format = "HH:mm";
      let get_general_settings = this.$store.getters.get_general_settings;
      if (
        get_general_settings &&
        get_general_settings.hasOwnProperty("time_format") &&
        get_general_settings.time_format === "12hrs"
      ) {
        format = "hh:mm a";
      }
      return format;
    },
    minute_interval() {
      let interval = 5;
      if (!this.time_data?.mm) {
        return interval;
      }
      interval = this.time_data.mm % 5 ? 1 : interval;
      return interval;
    }
  },
  methods: {
    handle_picker_change(event) {
      let t = event.data;
      let final = t.HH + ":" + t.mm + ":00";
      this.$emit("time-changed", final);
    }
  }
};
</script>
